module.exports = __webpack_public_path__ + "img/poleraparapersonalizada.50dfbe3e.png";